import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";

import { Button, Content, Input, Loading } from "components";

import { useState } from "react";
import { toast } from "react-toastify";
import { requestPasswordReset } from "services/auth";
import { IcoBackButton } from "assets/icons";
import { HeaderWithBack } from "components/HeaderBack";
import styles from "./styles.module.scss";

const ResetPasswordSchema = Yup.object().shape({
	email: Yup.string().required("Campo obrigatório")
});

export default function RetrievePasswordPage() {
	const [submitting, setSubmitting] = useState<boolean>(false);
	const [requested, setRequested] = useState<boolean>(false);
	const navigate = useNavigate();

	const formik = useFormik({
		initialValues: {
			email: ""
		},
		validationSchema: ResetPasswordSchema,
		onSubmit: async (values) => {
			setSubmitting(true);
			if (requested) {
				setSubmitting(false);
				navigate("/login");
				return;
			}

			await requestPasswordReset(values.email)
				.then(async (result) => {
					setSubmitting(false);
					setRequested(true);
				})
				.catch((error) => {
					setSubmitting(false);
					toast.error("Algo saiu errado, tente novamente", {
						position: "bottom-center",
						autoClose: 5000,
						hideProgressBar: true,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "light"
					});
				});
		}
	});

	return (
		<div className={styles.container}>
			<form onSubmit={formik.handleSubmit}>
				{requested ? (
					<Content className={styles.registerContainer}>
						<div className="mx-auto">
							<span>
								Um link foi enviado para o e-mail cadastrado para confirmar o
								acesso. Você deve recebê-lo em alguns momentos.
							</span>
						</div>

						<Button
							type="submit"
							variant="outline"
							disabled={!formik.isValid || !formik.dirty || submitting}
						>
							{submitting ? <Loading size="small" /> : "Entrar na conta"}
						</Button>
					</Content>
				) : (
					<div className={styles.registerContainer}>
						<HeaderWithBack label="Esqueci minha senha" backTo="/login" />
						<Input
							id="email"
							name="email"
							placeholder="seuemail@exemplo.com"
							label="Digite seu email"
							value={formik.values.email || ""}
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
							error={formik.touched.email && formik.errors.email}
							errorMessage={formik.errors.email}
							type="email"
						/>
						<Button
							type="submit"
							disabled={!formik.isValid || !formik.dirty || submitting}
						>
							{submitting ? <Loading size="small" /> : "Reenviar senha"}
						</Button>
					</div>
				)}
			</form>
		</div>
	);
}
